import React from 'react';
import { connect } from 'react-redux';
import { selectStoreCount } from 'core/selectors/app';

import './HowItWorks.scss';

function HowItWorks({ storeCount }) {
  return (
    <div className="mn_nagHowItWorks">
      <h3>Here's how it works</h3>
      <ul>
        <li>
          <h4><span className="mn_hiwStepIcon" id="mn_hiwSearchIcon" aria-hidden="true" />Search</h4>
          <p>Sign in with your MileagePlus username and browse {storeCount}+ online stores.</p>
        </li>
        <li>
          <h4><span className="mn_hiwStepIcon" id="mn_hiwShopIcon" aria-hidden="true" /> Shop</h4>
          <p>Click through to the store site and shop as you normally would.</p>
        </li>
        <li>
          <h4><span className="mn_hiwStepIcon" id="mn_hiwEarnIcon" aria-hidden="true" /> Earn</h4>
          <p>Miles are deposited into your MileagePlus account.</p>
        </li>
      </ul>
    </div>
  );
}

const mapStateToProps = state => ({
  storeCount: selectStoreCount(state),
});

export default connect(mapStateToProps)(HowItWorks);
